import {
  VehicleRecommendationState,
  GET_VEHICLE_RECOMMENDATION,
  GET_VEHICLE_RECOMMENDATION_SUCCESS,
  GET_VEHICLE_RECOMMENDATION_FAILURE,
  GET_VEHICLE_RECOMMENDATION_BYTOKEN,
  GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS,
  GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE,
  RESET_VEHICLE_RECOMMENDATION,
  VehicleRecommendationTypes,
} from "../types/vehicleRecommendationTypes";

const initialState: VehicleRecommendationState = {
  vehicleRecommendationSuccess: null,
  vehicleRecommendationError: null,
  vehicleRecommendationLoading: false,
  vehicleRecommendationList: [],
  vehicleRecommendationData: [],
};

export const vehicleRecommendationReducer = (
  state = initialState,
  action: VehicleRecommendationTypes
): VehicleRecommendationState => {
  switch (action.type) {
    case GET_VEHICLE_RECOMMENDATION: {
      return {
        ...state,
        vehicleRecommendationList: [],
        vehicleRecommendationSuccess: null,
        vehicleRecommendationError: null,
        vehicleRecommendationLoading: true,
      };
    }

    case GET_VEHICLE_RECOMMENDATION_SUCCESS: {
      return {
        ...state,
        vehicleRecommendationList: action.payload?.data,
        vehicleRecommendationSuccess: action.payload?.message,
        vehicleRecommendationError: null,
        vehicleRecommendationLoading: false,
      };
    }

    case GET_VEHICLE_RECOMMENDATION_FAILURE: {
      return {
        ...state,
        vehicleRecommendationError: action.payload,
        vehicleRecommendationSuccess: null,
        vehicleRecommendationLoading: false,
      };
    }

    case GET_VEHICLE_RECOMMENDATION_BYTOKEN: {
      return {
        ...state,
        vehicleRecommendationData: [],
        vehicleRecommendationSuccess: null,
        vehicleRecommendationError: null,
        vehicleRecommendationLoading: true,
      };
    }

    case GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS: {
      return {
        ...state,
        vehicleRecommendationData: action.payload?.data,
        vehicleRecommendationSuccess: action.payload?.message,
        vehicleRecommendationError: null,
        vehicleRecommendationLoading: false,
      };
    }

    case GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE: {
      return {
        ...state,
        vehicleRecommendationError: action.payload,
        vehicleRecommendationSuccess: null,
        vehicleRecommendationLoading: false,
      };
    }

    case RESET_VEHICLE_RECOMMENDATION: {
      return {
        ...state,
        vehicleRecommendationSuccess: null,
        vehicleRecommendationError: null,
        vehicleRecommendationLoading: false,
      };
    }

    default:
      return state;
  }
};
